var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilesforreviewicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6094 32.6719L27.0082 28.0707M7.70312 9.29688H10.3594M7.70312 14.6094H13.0156M15.6719 1.32812H5.04688C3.57983 1.32812 2.39062 2.51733 2.39062 3.98438V30.0156C2.39062 31.4825 3.57983 32.6719 5.04688 32.6719H13.0156M15.6719 1.32812V6.64062C15.6719 8.10761 16.8611 9.29688 18.3281 9.29688H23.6406M15.6719 1.32812L23.6406 9.29688M23.6406 11.9531V9.29688",
    stroke: "#3CD8E9",
    strokeWidth: 2.65625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 30.0156C25.98 30.0156 28.9531 27.0425 28.9531 23.375C28.9531 19.7075 25.98 16.7344 22.3125 16.7344C18.645 16.7344 15.6719 19.7075 15.6719 23.375C15.6719 27.0425 18.645 30.0156 22.3125 30.0156Z",
    stroke: "#3CD8E9",
    strokeWidth: 2.65625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesforreviewicon);
export default __webpack_public_path__ + "static/media/filesforreviewicon.b5e052dede8a599a64aac0eace63177f.svg";
export { ForwardRef as ReactComponent };